import Vue from 'vue';
import App from './App.vue';
import router from './router';

import { Button, Cell, Icon, Form, Field, CellGroup, Switch, NavBar, Toast, Loading, List, PullRefresh, Popup, NoticeBar, Tabs, Tab, SwipeCell, Dialog, DatetimePicker } from 'vant';

// 引入 Vant 的基础样式
import 'vant/lib/index.css';
// 引入 Vant 的本地图标字体样式
import 'vant/lib/icon/local.css';

Vue.use(Button);
Vue.use(Cell);
Vue.use(Icon);
Vue.use(Form);
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Switch);
Vue.use(NavBar);
Vue.use(Toast);
Vue.use(Loading);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Popup);
Vue.use(NoticeBar);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(SwipeCell);
Vue.use(Dialog);
Vue.use(DatetimePicker);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
